/**
 * Kait baca untuk `/items/<collection>` (local mode). Di backend sungguhan aturan otomatis dijalankan worker SLA; di
 * local mode sweep dijalankan setiap koleksi terkait dibaca (daftar / detail) — pola `sweepDiscrepancies()`. Handler
 * mendaftarkan kaitnya saat `register…Handlers` dipanggil; `items.handler` memanggilnya sebelum membaca.
 */
const hooks = new Map<string, () => void>()

export const registerReadHook = (collections: string[], run: () => void) =>
  collections.forEach(collection => hooks.set(collection, run))

/** Menjalankan kait; galat sweep tidak pernah menggagalkan pembacaan. */
export function runReadHook(collection: string) {
  try {
    hooks.get(collection)?.()
  } catch (error) {
    console.warn('[local-db] sweep baca gagal (diabaikan):', error)
  }
}
